import React from 'react';
import { Box, Link } from '@chakra-ui/react';
import { NavDropdownItem } from '../navigationData';

interface DropdownCardProps {
  item: NavDropdownItem;
  gradientId: string;
  onClick?: () => void;
}

const DropdownCard: React.FC<DropdownCardProps> = ({ item, gradientId, onClick }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const Icon = item.icon;

  return (
    <Link
      href={item.href}
      _hover={{ textDecoration: 'none' }}
      _focus={{ outline: 'none', boxShadow: 'none' }}
      _focusVisible={{ outline: 'none', boxShadow: 'none' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <Box
        p={4}
        borderRadius="xl"
        border="2px solid"
        borderColor={isHovered ? item.accentColor : 'transparent'}
        bg={isHovered ? 'gray.50' : 'white'}
        transition="all 0.25s ease"
        height="100%"
        display="flex"
        flexDirection="column"
      >
        <Box
          display="flex"
          alignItems="center"
          gap={3}
          mb={2}
        >
          <Box
            flexShrink={0}
            className="dropdown-card-icon"
            data-gradient={gradientId}
          >
            <Icon size={20} />
          </Box>
          <Box fontFamily="lato" fontWeight="bold" color="#13131B" fontSize="sm">
            {item.title}
          </Box>
        </Box>
        <Box fontFamily="lato" color="gray.500" fontSize="xs" lineHeight="1.5">
          {item.description}
        </Box>
      </Box>
    </Link>
  );
};

export default DropdownCard;
